import React from "react";
import "../stylesheets/About.css";

class About extends React.Component {
  Member = ({
    imgSource,
    name,
    role,
    portfolioLink,
    linkedInLink,
    artStationLink,
    bio,
  }) => {
    const isLinked = (linkToCheck, faString) => {
      if (linkToCheck) {
        return (
          <li>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.open(`${linkToCheck}`, "_blank");
              }}
            >
              <i className={`${faString}`}></i>
            </a>
          </li>
        );
      }
    };

    return (
      <div className="member">
        <img className="member-img" src={imgSource} alt={`${name}`} />
        <h2 className="member-name">{name}</h2>
        <h3 className="member-role">{role}</h3>
        <p className="member-bio">{bio}</p>
        <ul className="member-contact-list">
          {isLinked(linkedInLink, "fab fa-linkedin")}
          {isLinked(artStationLink, "fab fa-artstation")}
          {isLinked(portfolioLink, "fas fa-address-book")}
        </ul>
      </div>
    );
  };

  render() {
    return (
      <div className="about-container" id="about">
        <div className="about">
          <h1 className="about-title">About Us</h1>
          <div className="about-members">
            <this.Member
              imgSource="./memberImages/Fredrick.jpg"
              name="Prakhhar Makhija (Fred)"
              linkedInLink="https://www.linkedin.com/in/prakhhar-makhija/"
              portfolioLink="https://pmak.dev/"
              role="AI & Gameplay Programmer"
              bio="Highly passionate coder excelling in Game and Front-End Development.
              Author of this website made using React. 
              AI and Gameplay Programmer for Project Steelwalker.
              Super keen to learn more."
            />
            <this.Member
              imgSource="./memberImages/Arianne.jpg"
              name="Arianne Fennell"
              role="UI Technical Artist"
              // portfolioLink="www.ariannefennell.ca"
              linkedInLink="https://www.linkedin.com/in/arianne-fennell/"
              portfolioLink="https://www.ariannefennell.ca/"
              bio="Arianne is a UI 
              Technical Artist who specializes in video games.
               With the goal of helping teams bridge the gap
                between both art and programming, she has 
                experience implementing user interfaces in 
                Unreal Engine 4, Unity, and custom C++ engines.
                 She is currently working on Dead by Daylight at
                  Behaviour Interactive."
            />
            <this.Member
              imgSource="./memberImages/Jeffrey.jpg"
              name="Jeffrey Armstrong"
              role="Gameplay Programmer"
              bio="Jeffrey Armstrong is currently a student studying
               Game Dev at Algonquin College. He is hoping for a
               career as a Gameplay Programmer and Script Writer
               at a professional studio. In Project SteelWalker,
               he is handling some of the Gameplay Mechanics including
               Character Abilities and Level Elements."
            />
            <this.Member
              imgSource="./memberImages/Nathan.png"
              name="Nathan Sherwood"
              linkedInLink="https://www.linkedin.com/in/nathan-sherwood-b73630110/"
              artStationLink="https://ltmcmuffin.artstation.com/"
              role="3D Artist"
              bio={`Nathan Sherwood has been doing 3d modeling for
              various small groups since 2018. After a year and a
              half learning various art programing related programs 
              at Carleton's Interactive multimedia Design school,
              he decided to focus on Game Development at Algonquin.
              Notable Projects include models for Project Gold's
              Humanity's retaliation, MechWarriors Living Legends 
              Community Edition, and of course Project SteelWalker.
              `}
            />
            <this.Member
              imgSource="./memberImages/Donovan.jpg"
              name="Donovan de Carle"
              role="Level Design"
              bio="Donovan is a Design artist who flourishes 
              in landscape/environmental design as well as 
              particle systems. With a love for environmental 
              storytelling and open world games he has a good 
              eye for the beauty that should be captured in 
              these areas."
            />
            <this.Member
              imgSource="./memberImages/Richard.png"
              name="Richard Hillsdon"
              role="3D Artist"
              bio="Richard Hillsdon is a jack of all trades and 
              burdgeoning game design enthusiast. From an early 
              age, Richard has been dabbling in various forms 
              of game design from early Source Engine modding 
              to Tabletop RPG Modules. Currently, Richards main 
              role is that of 3D artist, focusing on texture work 
              and prop modeling."
            />
            <this.Member
              imgSource="./memberImages/Patrick.png"
              name="Patrick McComber"
              role="3D Artist"
              bio="Creative and driven artist specializing in 3D 
              modelling, both hard surface and organic. Keen to 
              further his knowledge on all things 3D. Art contact 
              for Project Steelwalker."
            />
            <this.Member
              imgSource="./memberImages/Hamid.jpg"
              name="Hamidreza Ghasemi"
              linkedInLink="https://www.linkedin.com/in/hamidreza-g-829735197/"
              portfolioLink="https://www.ghasemi.dev/"
              role="Tools Developer & Technical Artist"
              bio="Hamidreza is a proficient and detail-oriented 
              programmer with a strong mathematical background and 
              an eye for aesthetics. He directs the programming 
              efforts of the project, develops tools to empower 
              the artists and designers, contributes as a tech 
              artist and composes the music for project SteelWalker. "
            />
            <this.Member
              imgSource="./memberImages/Christian.jpg"
              name="Christian Young"
              linkedInLink="https://www.linkedin.com/in/christian-a-young/"
              portfolioLink="https://www.cyoungportfolio.com/"
              role="Network & Gameplay Programming"
              bio="Christian is a Networking Specialist for Project Steelwalker,
               but is always willing to help wherever he is needed. He has a 
               drive to try and push himself into uncomfortable situations in 
               order to learn something new, and is always wanting to expand 
               his knowledge, he has worked on networking for both Project 
               Steelwalker and ShadowStalk and has also worked on Gameplay 
               features as well."
            />
          </div>
        </div>
      </div>
    );
  }
}

export default About;
